import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { UsuariosComponent } from '../../sub-filtros/usuarios/usuarios.component';
import { heroClockMicro } from '@ng-icons/heroicons/micro';
import { heroChevronLeftMini } from '@ng-icons/heroicons/mini';
import {
  heroMapPinSolid,
  heroUserGroupSolid,
  heroCalculatorSolid,
} from '@ng-icons/heroicons/solid';
import { StatusNegocioComponent } from '../../sub-filtros/status-negocio/status-negocio.component';
import { find, Subscription } from 'rxjs';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { FiltroCotacoesRamoService } from '../cotacoes-ramo/filtro-cotacoes-ramo.service';
import { registerCloseOtherMenus } from '../../filtro-utils';

@Component({
  selector: 'filtro-lista-negocios',
  templateUrl: './lista-negocios.component.html',
  styleUrls: ['./lista-negocios.component.scss'],
  providers: [
    provideIcons({
      heroClockMicro,
      heroChevronLeftMini,
      heroMapPinSolid,
      heroUserGroupSolid,
      heroCalculatorSolid,
    }),
  ],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatTooltipModule,
    NgIcon,
    MatMenuModule,
    UsuariosComponent,
    StatusNegocioComponent,
  ],
})
export class ListaNegociosComponent implements OnInit {
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();
  @Input('listaUsuarios') listaUsuarios: any = {};
  @ViewChildren(MatMenuTrigger) allTriggers!: QueryList<MatMenuTrigger>;

  listaStatusNegocio = [
    { value: 1, viewValue: 'Oportunidade' },
    { value: 2, viewValue: 'Início' },
    { value: 3, viewValue: 'Cotação' },
    { value: 4, viewValue: 'Acompanhamento' },
    { value: 5, viewValue: 'Fechado' },
    { value: 6, viewValue: 'Perdido' },
    { value: 7, viewValue: 'Descartado' },
    { value: 8, viewValue: 'Fechado e concluído' },
  ];

  filtroRamo: { ramo: string; subRamos: string[] }[] = [];
  filtroUsuario = [];
  filtroStatusNegocio:number[] = [];

  private tabSubscription!: Subscription;
  private clearSubscription!: Subscription;

  protected ramosTabs = IntegracaoConstants.ramosTabs;

  protected currentTab = this.ramosTabs[0];

  constructor(
    public filtroController: FiltroControllerService,
    private filtroCotacoesRamoService: FiltroCotacoesRamoService
  ) {}

  ngOnInit() {
    this.inicializaFiltros();
    this.tabSubscription = this.filtroCotacoesRamoService.currentTab$.subscribe(
      (tab) => {
        this.currentTab = this.ramosTabs.find((x) => x.id == tab);
      }
    );

    this.clearSubscription = this.filtroCotacoesRamoService.clear$.subscribe(
      () => {
        this.clearFilter();
      }
    );
  }

  ngAfterViewInit() {
    registerCloseOtherMenus(this.allTriggers);
  }

  ngOnDestroy() {
    this.tabSubscription.unsubscribe();
    this.clearSubscription.unsubscribe();
  }

  inicializaFiltros() {
    if (this.filtroController.filtroListaNegocio) {
      const { status, userSelected } = this.filtroController.filtroListaNegocio;

      this.filtroUsuario = userSelected ?? [];

      this.filtroStatusNegocio = status ?? [];

      this.verificaStatusNegocioSelecionado();
    }
  }

  atualizaFiltroStatusNegocio(payload: { negocio: number; newValue: boolean }) {
    const { negocio, newValue } = payload;

    if (!newValue) {
      let index = this.filtroStatusNegocio.findIndex((s) => s == negocio);
      this.filtroStatusNegocio.splice(index, 1);
      return;
    }

    for (let status of this.listaStatusNegocio) {
      if (status.value == negocio) {
        this.filtroStatusNegocio.push(negocio);
        break;
      }
    }

    this.filtroController.updateActiveFilters("status", this.filtroStatusNegocio.length);
  }

  limpaFiltroStatusNegocio() {
    this.filtroStatusNegocio = [];
    for (let item of this.listaStatusNegocio) {
      item['ativo'] = false;
    }
  }

  verificaStatusNegocioSelecionado() {
    for (let item of this.listaStatusNegocio) {
      for (let id of this.filtroStatusNegocio) {
        if (item.value === id) item['ativo'] = true;
      }
    }
  }

  buildString() {
    this.filtroController.addFiltrosExtras('listaNegocios', {
      status: this.filtroStatusNegocio,
      userSelected: this.filtroUsuario,
    });

    const rawValue = {
      status: this.filtroStatusNegocio,
      userSelected: this.filtroUsuario,
    };

    const filtros = { values: rawValue };

    this.filtroController.verificaFiltro();
    this.eventFilter.emit(filtros);

    return filtros;
  }

  clearFilter() {
    this.filtroUsuario = [];
    this.limpaFiltroStatusNegocio();
    this.filtroController.limparFiltro('listaNegocios');
    this.filtroController.verificaFiltro();
    this.limpaFiltro.emit();
    this.buildString();
  }

  private findUser(userData: string) {
    const todosUsuarios = [
      ...this.listaUsuarios?.ativos,
      ...this.listaUsuarios?.inativos,
    ];
    
    const user = todosUsuarios.find((x) => x.email == userData || x.id == userData);

    return user;
  }

  getUsersCount(){
    const userFilter = this.filtroController.getActiveFilter("users");

    return userFilter ?? 0;
  }

  getStatusCount(){
    return this.filtroStatusNegocio.length ?? 0;
  }
}
